import axios from './api'
import APP_ENVIRONMENT from '../environment/environment'
import localStorageService from './localStorage'
// getMandantTableData: solo la usaba robinHoodExcelReport (RobinHood v1, fuera de operación).
// import { getMandantTableData } from '../pages/admin/components/MandantTable'
const URL_REPORT = APP_ENVIRONMENT.PATH.REPORT
const URL_WEB = APP_ENVIRONMENT.BASE_URL_WEBSITE
//Creare y descargar excel
async function offerExcelReport(auction) {
  try {
    const response = await axios.post(`${URL_REPORT}/offer/excel`,
      {
        auctionId: auction.id,
        timeZoneOffset: new Date().getTimezoneOffset(),
      },
      {
        headers: {
          Authorization: `Bearer ${localStorageService.get('token')}`,
        },
        responseType: 'arraybuffer',
      }
    )
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Ofertas.xlsx')
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  } catch (error) { console.log(error) }
}

async function chatExcelReport(auction) {


  try {
    const response = await axios.post(
      `${URL_REPORT}/chat/excel`,
      { auctionId: auction.id, timeZoneOffset: new Date().getTimezoneOffset() },
      {
        headers: {
          Authorization: `Bearer ${localStorageService.get('token')}`,
        },
        responseType: 'arraybuffer',
      }
    )
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `chats-${auction.id}.xlsx`)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  } catch (error) { }
}

// Código legado del RobinHood anterior a este rediseño, fuera de operación.
// async function robinHoodExcelReport(auctionId, dataLotInfo) {
//   try {
//     const response = await axios.post(
//       `${URL_REPORT}/robin/hood`,
//       {
//         auctionId: auctionId,
//         timeZoneOffset: new Date().getTimezoneOffset(),
//         data: dataLotInfo,
//         mandantData: getMandantTableData(dataLotInfo)
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${localStorageService.get('token')}`,
//         },
//         responseType: 'arraybuffer',
//       }
//     )
//     const url = window.URL.createObjectURL(new Blob([response.data]))
//     const link = document.createElement('a')
//     link.href = url
//     link.setAttribute('download', 'RobinHood.xlsx')
//     document.body.appendChild(link)
//     link.click()
//     link.parentNode.removeChild(link)
//   } catch (error) {
//     console.log(error)
//   }
// }
async function lotOffersExcelReport({ auctionId, areaId, token }) {
  try {

    const { data } = await axios.get(`${URL_WEB}/api/v1/guarantees/getLotsWithOffers?areaId=${areaId}&auctionId=${auctionId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    const { lots, awards } = data
    const response = await axios.post(
      `${URL_REPORT}/offer/excelOffersLots`,
      {
        lots: lots,
        awards: awards
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'arraybuffer',
      }
    )
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'LotOffers.xlsx')
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  } catch (error) {
    console.log(error)
  }
}

async function robinHoodExcelReport({ auctionId }) {
  try {
    const response = await axios.post(
      `${URL_REPORT}/robin/excel`,
      { auctionId },
      {
        headers: {
          Authorization: `Bearer ${localStorageService.get('token')}`,
        },
        responseType: 'arraybuffer',
      }
    )
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `RobinHood-${auctionId}.xlsx`)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  } catch (error) {
    console.log(error)
  }
}

async function pollAuctionExcelReport({ auctionId }) {
  try {
    const response = await axios.post(
      `${URL_REPORT}/poll/poll`,
      {
        auctionId: auctionId,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorageService.get('token')}`,
        },
        responseType: 'arraybuffer',
      }
    )
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    // 
    link.setAttribute('download', `AUCTIONPULL/${auctionId}.xlsx`)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  } catch (error) {
    console.log(error)
  }

}
// Código legado del RobinHood anterior a este rediseño, fuera de operación.
// async function putRobinHoodReportDynamo(auctionId, dataLotInfo) {
//   try {
//     const config = {
//       auctionId: auctionId,
//       lotData: dataLotInfo
//     }
//     await axios.put(
//       `${URL_REPORT}/robin/putDynamoDBRobinHoodAuction`, config
//     )
//   } catch (error) {
//     console.log(error)
//   }
// }
async function userExcelReport(connectedUsers, reportPresentialUser, areaId, awards) {


  try {
    const response = await axios.post(
      `${URL_REPORT}/user/generateReport`,
      {
        connectedUsers: connectedUsers,
        reportPresentialUser: reportPresentialUser,
        areaId: areaId,
        awards: awards,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorageService.get('token')}`,
        },
        responseType: 'arraybuffer',
      }
    )
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'UserList.xlsx')
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  } catch (error) {
    console.log(error)
  }
}

// Código legado del RobinHood anterior a este rediseño, fuera de operación.
// async function massiveLoadRH(auctionId, data) {
//   try {
//     const config = {
//       auctionId: auctionId,
//       data: data.infoMandant,
//     }
//     await axios.post(
//       `${URL_REPORT}/robin/massiveLoad`, config
//     )
//   } catch (error) {
//     console.log(error)
//   }
// }

const reportApi = {
  offerExcelReport,
  chatExcelReport,
  // robinHoodExcelReport, // Código legado del RobinHood anterior a este rediseño, fuera de operación
  pollAuctionExcelReport,
  robinHoodExcelReport,
  // putRobinHoodReportDynamo, // Código legado del RobinHood anterior a este rediseño, fuera de operación
  // massiveLoadRH, // Código legado del RobinHood anterior a este rediseño, fuera de operación
  userExcelReport,
  //experimental
  lotOffersExcelReport
}

export default reportApi
